window.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.pro-welcome-notice').forEach((notice) => {
    notice.querySelector('.pro-welcome-notice__close-icon').addEventListener('click', (e) => {
      e.preventDefault();
      notice.classList.add('pro-welcome-notice--hide');
      if (notice.dataset.id) {
        document.cookie = `${notice.dataset.id}=dismissed`;
      }
    });
  });
});
